import type { ReactNode } from 'react';

/** What a browse pane shows instead of content: loading, empty, or nothing picked yet. */
export const PanelState = ({ icon, children }: { icon: ReactNode; children: ReactNode }) => (
  <div className='flex flex-1 flex-col items-center justify-center gap-2 px-4 py-10 text-center text-xs text-gray-800'>
    {icon}
    {children}
  </div>
);
